import React from "react";
import { Typography } from "@mui/material";
import FadeLoader from "react-spinners/FadeLoader";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { StatusMessageContainer, StatusIcon } from "../styles";

interface StatusContentProps {
    t: (key: string) => string;
    isFadeLoading: boolean;
    dispenseStatusMessage: string;
}

const StatusContent: React.FC<StatusContentProps> = ({ t, isFadeLoading, dispenseStatusMessage }) => {
    return (
        <StatusMessageContainer>
            <Typography className="typography1">{t("paymentSUCCESS")}</Typography>
            <StatusIcon>
                {isFadeLoading ? (
                    <FadeLoader loading={isFadeLoading} height={18} width={4} />
                ) : (
                    <CheckCircleIcon
                        style={{
                            color: "#2ba703",
                            fontSize: "40px",
                        }}
                    />
                )}
            </StatusIcon>
            <Typography className="typography2">{dispenseStatusMessage}</Typography>
        </StatusMessageContainer>
    );
};

export default StatusContent;
